export const options = [
  {
    id: 'interested',
    title: 'Yes',
    description: 'I am interested in payment options',
    allowProgression: true,
  },
  {
    id: 'cover-cost',
    title: 'No',
    description: "I'll cover the cost of my appointment",
    allowProgression: true,
  },
  {
    id: 'social-assistance',
    title: 'No',
    description: "I'll use a social assistance program",
    allowProgression: false,
  },
];
